"use client";

import React from "react";
import dynamic from "next/dynamic";
import Banner from "./index/banner";
const LeaderNote = dynamic(() => import("./index/leader-note"), { ssr: true });
const BookSection = dynamic(() => import("./index/book-section"), {
  ssr: true,
});
const ExecutiveTeam = dynamic(() => import("./index/executive-team"), {
  ssr: true,
});
const LeadershipPillars = dynamic(() => import("./index/leadership-pillars"), {
  ssr: true,
});
const HocHead = dynamic(
  () => import("@/Components/HigherOrderComponent/HocHead"),
  { ssr: true }
);
interface BaseBlock {
  __component: string;
  [key: string]: any;
}

interface SeoData {
  title?: string;
  description?: string;
  [key: string]: any;
}

interface LeadershipPageProps {
  data: {
    slug: string;
    seo?: SeoData;
    blocks: BaseBlock[];
  };
}

const LeadershipPage: React.FC<LeadershipPageProps> = ({ data }) => {
  const { blocks, seo }: any = data ?? {};

  return (
    <>
      {seo && <HocHead seo={seo} />}
      {Array.isArray(blocks) && blocks.length > 0 && (
        <div className="leadershipPage bg-one">
          {blocks.map((block: any, i: number) => (
            <div key={i}>
              {block?.__component === "blocks.home-new-banner" && (
                <Banner block={block} />
              )}
              {block?.__component === "blocks.meet-our-team" && (
                <ExecutiveTeam block={block} slug={data?.slug} />
              )}
              {block?.__component === "blocks.leadership-pillar" && (
                <LeadershipPillars block={block} />
              )}
              {block?.__component === "blocks.founder-notes" && (
                <LeaderNote block={block} />
              )}
              {block?.__component === "blocks.cta" && (
                <BookSection block={block} />
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default LeadershipPage;
